module.exports = __webpack_public_path__ + "static/media/3dmodeling_11.64aab09b.png";